import { render, staticRenderFns } from "./PackagesForm.vue?vue&type=template&id=5d745ed2&"
import script from "./PackagesForm.vue?vue&type=script&lang=js&"
export * from "./PackagesForm.vue?vue&type=script&lang=js&"
import style0 from "./PackagesForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports